import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FormSummary from './components/form-summary/FormSummary';
import FormList from './containers/form-list/FormList';
import FormCms from './containers/form/Form';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/*' element={<FormCms></FormCms>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
